import React, { Fragment, useEffect } from "react";
import { Prompt } from "react-router";

/* Helper function which blocks both browser and React Router navigation
    user must confirm their intent before navigation will proceed */

const MESSAGE: string = "Changes that you made may not be saved.";
const beforeunload = (event: any) => {
  event.returnValue = MESSAGE;
};

export const removeBeforeunloadListener = () => {
  window.removeEventListener("beforeunload", beforeunload);
};

export const OnBeforeUnload = () => {
  useEffect(() => {
    window.addEventListener("beforeunload", beforeunload);
    return removeBeforeunloadListener;
  }, []);

  const token = window.localStorage.getItem("token");
  return (
    <Fragment>
      <Prompt when={!!token} message={MESSAGE} />
    </Fragment>
  );
};
